define('shared/remote/efid/get',['./cache'], function (cache) {
    return function(id){
        return cache.get(id);
    };
});
